import typeImg from '@/assets/images/tyre.png'
import { reorganizeTyreName } from '@/util/order/handle'
import { isNum } from '@/util/index'

// 格式化购物车列表数据
export const couponList = data => {
  const planList = data
    .filter(item => item.loyaltyTypeFlag == 1 && item.productType === 1 && item.delStatusFlag === 0)
    .map(item => {
      item.buyAmountLimit = item.buyStatusFlag === 1 ? 1 : item.buyAmountLimit
      item.productQuantity = Math.min.apply(Math, [item.buyAmountLimit, item.productQuantity])
      const {
        planImage = [],
        productName,
        name,
        licensePlate,
        gsCode,
        uniformPrice,
        productQuantity,
        id,
        model,
        buyAmountLimit,
        priceTypeFlag,
        address,
        carAge,
        vin,
        fin,
        licensePlate: plate,
        payTypeFlag,
        depositPrice
      } = item
      item.carInfo = { carAge, vin, fin, plate, model }
      item.dealerInfo = { address, name }
      let carInf = `车辆：${licensePlate || '暂无车牌号'}  | ${model || ''} `
      if (payTypeFlag == 3) {
        carInf = `车辆：暂不选择车辆`
      }
      return {
        imgSrc: planImage[0]?.imageUrl,
        productName: productName,
        dealerName: name,
        gsCode,
        carInf,
        price: uniformPrice,
        uniformPrice: uniformPrice,
        num: productQuantity,
        id,
        buyAmountLimit,
        priceTypeFlag,
        computePrice: isNum(item.indPrice) ? item.indPrice : uniformPrice,
        payTypeFlag,
        depositPrice,
        _data: item
      }
    })
  const tyreList = data
    .filter(item => item.productType === 2 && item.delStatusFlag === 0)
    .map(item => {
      const { name, gsCode, uniformPrice, productQuantity, id, buyAmountLimit, stockAmount } = item
      return {
        imgSrc: typeImg,
        productName: reorganizeTyreName(item),
        dealerName: name,
        gsCode,
        carInf: ``,
        price: uniformPrice,
        num: Math.min.apply(Math, [productQuantity, stockAmount]),
        id,
        buyAmountLimit,
        _data: item,
        hasProduct: stockAmount >= 1,
        computePrice: isNum(item.indPrice) ? item.indPrice : uniformPrice
      }
    })
  const tyrePlanList = data
    .filter(item => item.loyaltyTypeFlag == 2 && item.productType === 1 && item.delStatusFlag === 0)
    .map(item => {
      item.productQuantity = Math.min.apply(Math, [item.buyAmountLimit, item.productQuantity])
      const {
        planImage = [],
        productName,
        name,
        licensePlate,
        gsCode,
        uniformPrice,
        productQuantity,
        id,
        model,
        buyAmountLimit,
        priceTypeFlag,
        address,
        carAge,
        vin,
        fin,
        licensePlate: plate,
        payTypeFlag,
        depositPrice
      } = item
      item.carInfo = { carAge, vin, fin, plate, model }
      item.dealerInfo = { address, name }
      let carInf = `车辆：${licensePlate || '暂无车牌号'}  | ${model || ''} `
      if (payTypeFlag == 3) {
        carInf = `车辆：暂不选择车辆`
      }
      return {
        imgSrc: planImage[0]?.imageUrl,
        productName: productName,
        dealerName: name,
        gsCode,
        carInf,
        price: uniformPrice,
        uniformPrice: uniformPrice,
        num: productQuantity,
        id,
        buyAmountLimit,
        priceTypeFlag,
        computePrice: isNum(item.indPrice) ? item.indPrice : uniformPrice,
        payTypeFlag,
        depositPrice,
        _data: item
      }
    })
  const shopList = data
    .filter(item => (item.productType === 3 && item.delStatusFlag === 0) || item.bizType === 'EW')
    .map(item => {
      const {
        productName,
        productNames,
        thumbnail,
        name,
        licensePlate,
        changedFlag,
        gsCode,
        price,
        productQuantity,
        id,
        model,
        buyAmountLimit,
        priceTypeFlag,
        address,
        carAge,
        vin,
        fin,
        licensePlate: plate
      } = item
      item.productType = 3
      item.carInfo = { carAge, vin, fin, plate, model }
      item.dealerInfo = { address, name }
      return {
        _en: 'heyue',
        imgSrc: thumbnail,
        productName: productName,
        productNames,
        dealerName: name,
        isEW: item.bizType === 'EW',
        gsCode,
        carInf: `${licensePlate || '暂无车牌号'}  | ${model || ''} `,
        price: changedFlag ? null : price,
        num: item.bizType === 'EW' ? 1 : productQuantity,
        id,
        buyAmountLimit,
        priceTypeFlag,
        // computePrice: isNum(item.indPrice) ? item.indPrice : uniformPrice,
        _data: { ...item }
      }
    })
  const planData = {
    title: '致友计划',
    checkAll: planList.length === 0,
    type: 'planData',
    list: planList
  }
  const tyreData = {
    title: '轮胎',
    checkAll: tyreList.length === 0,
    type: 'tyreData',
    list: tyreList
  }
  const tyrePlanData = {
    title: '轮胎套餐计划',
    checkAll: tyrePlanList.length === 0,
    type: 'tyrePlanData',
    list: tyrePlanList
  }
  const shopData = {
    title: '',
    checkAll: shopList.length === 0,
    type: 'shopData',
    list: shopList
  }
  const goodNum = planList.length + tyreList.length + shopList.length + tyrePlanList.length
  return {
    tyrePlanData,
    planData,
    tyreData,
    shopData,
    goodNum
  }
}
// 缓存物品数据到本地
export const setConfirmGoodsStore = (store, data) => {
  if (!store || !data) return
  store.commit('SETLOYALTYID', data.productId)
  store.dispatch('setDealerInfo', {
    gs_code: data.gsCode,
    name: data.name,
    tel: data.tel
  })
  store.dispatch('setCurrentCarInfo', {
    plate: data.licensePlate,
    model: data.model,
    baumuster: data.baumuster,
    id: data.customerCarId
  })
  store.dispatch('setCurrentGoodsInfo', {
    img: data.imgSrc,
    name: data.productName,
    uniformPrice: data.uniformPrice,
    depositPrice: data.depositPrice,
    id: data.productId,
    loyaltyId: data.productId,
    priceTypeFlag: data.priceTypeFlag,
    loyaltyTypeFlag: data.loyaltyTypeFlag,
    productType: data.productType,
    shoppingCarDetailId: data.id
  })
  store.dispatch('setBrandInfo', { brand: data.brand, spec: data.spec, productNo: data.productNo, productItem: data.productNo })
}
